import React from 'react'

import { showToast } from '../../../../helpers/notify'
import Link from '../../../../components/Link'
import AsyncGet from '../../../../components/AsyncGet'

import style from '../style.module.css'

const ResendOTP = ({ email }) => {
    return (
        <AsyncGet
            url="/account/resend-otp"
            method="post"
            permissionText={false}
            paramsData={{email}}
            onFetch = {({data}) => {
                showToast(data.message)
            }}
            render={({loadFromAPI}) => {
                return (
                    <div className={style.resendOtp}>
                        <span>Didn't receive the OTP? </span>
                        <Link 
                            className={`${style.resendButton}`} 
                            onClick={loadFromAPI}
                        >
                            Send OTP
                        </Link>
                    </div>
                )
            }}
        />
    )
}

export default ResendOTP